import { TransitionGate } from '../../services/crossMarketApi';

export default function SystemGateRail({ gates }: { gates: TransitionGate[] }) {
  return (
    <section className="system-panel">
      <div className="system-section-head">
        <div>
          <span className="system-kicker">EVIDENCE GATES</span>
          <h2>운영 안전 단계</h2>
        </div>
        <p>실제 주문 가능 여부는 시장별 switch와 검증 증거를 함께 봅니다.</p>
      </div>
      <div className="gate-rail">
        {gates.map((gate) => (
          <article key={gate.key} className={`gate-item ${gate.status}`}>
            <span>{gate.key}</span>
            <strong>{gate.label}</strong>
            <small>{statusLabel(gate.status)}</small>
          </article>
        ))}
      </div>
    </section>
  );
}

function statusLabel(status: TransitionGate['status']) {
  return ({
    complete: '완료', technical_complete: '기술 기준선 완료',
    in_progress: '진행 중', pending: '대기', locked: '잠김',
    ready_locked: '준비됨 · 잠금',
  } as Record<string, string>)[status];
}
